<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="Appraisal"></IndexBase>

    <Dialog v-model:visible="lockedDialog" :closable="false" :modal="true"
        :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '25vw' }" :closeOnEscape="false"
        :header="$t('locked_score')">
        <p>
            {{ $t('locked_score_msg') }}
        </p>
        <template #footer>
            <Button label="OK" class="p-button mr-2" @click="backToIndex" />
        </template>
    </Dialog>

    <Dialog v-model:visible="scoreSelectionDialog" :closable="false" :modal="true"
        :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '50vw' }" :closeOnEscape="false"
        :header="$t('message.select_score')">
    
    <div class="score-selection-container">
        <div class="score-option" :class="{ 'disabled-option': !selectedRowData?.S_Edit }">
            <Button 
                label="Select" 
                class="p-button p-button-primary select-btn"
                :disabled="!selectedRowData?.S_Edit"
                @click="selectScore('superior')" />
            <div class="score-label">Superior</div>
            <div class="score-details">
                <div>{{ selectedRowData?.S_Edit || '-' }}</div>
                <div>{{ selectedRowData?.S_Score ? 'Total Score : ' + selectedRowData.S_Score + '% ' + '(' + selectedRowData.S_Rate + ')' : '-' }}</div>
            </div>
        </div>
        
        <div class="score-option" :class="{ 'disabled-option': !selectedRowData?.F_Edit }">
            <Button 
                label="Select" 
                class="p-button p-button-primary select-btn"
                :disabled="!selectedRowData?.F_Edit"
                @click="selectScore('functional')" />
            <div class="score-label">Functional</div>
            <div class="score-details">
                <div>{{ selectedRowData?.F_Edit || '-' }}</div>
                <div>{{ selectedRowData?.F_Score ? 'Total Score : ' + selectedRowData.F_Score + '% ' + '(' + selectedRowData.F_Rate + ')' : '-' }}</div>
            </div>
        </div>
    </div>
    
    <!-- Notes section -->
    <div v-if="!selectedRowData?.F_Edit || !selectedRowData?.S_Edit" class="notes-section">
        <div class="notes-title">Notes:</div>
        <div v-if="!selectedRowData?.S_Edit" class="notes-item">
            <i class="pi pi-lock" style="color: #dc3545;"></i>
            Superior has not completed the review
        </div>
        <div v-if="!selectedRowData?.F_Edit" class="notes-item">
            <i class="pi pi-lock" style="color: #dc3545;"></i>
            {{ $t('message.functional_not_assess') }}
        </div>
    </div>
    
    <template #footer>
        <Button label="Cancel" class="p-button-outlined" @click="scoreSelectionDialog = false" />
    </template>
</Dialog>

    <Card id="cardAppraisal">
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{ $t('appraisal') }}
                    </div>
                </template>
                <template #right>
                    <div class="p-card-title" style="margin-top:10px;">
                        <Button type="button" class="p-button-warning p-button-sm" label="Export" @click="exportExcel()"
                            icon="pi pi-file-excel" v-if="this.dataModel && this.dataModel.length > 0" />
                    </div>
                </template>
            </Toolbar>
            <Toolbar>
                <template #left>
                    <div class="alert alert-info"><b>{{ this.$t('note.mydata') }}</b>
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <div class="p-fluid mb-3">
                <CustomSelectButton v-model="selectedStatus" :options="statusList" optionLabel="option"
                    class="p-text-center" @change="onStatusChange" :setDefault="true">
                    <template #option="slotProps">
                        <div class="p-text-center" style="width:100%">{{ slotProps.option }}</div>
                    </template>
                </CustomSelectButton>
            </div>

            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple"
                removableSort v-model:expandedRows="expandedRows" stateStorage="local" :stateKey="stateKey"
                :value="dataModel" :loading="!dataModel || loading" :paginator="true" :rows="10" :lazy="true"
                v-model:first="this.start"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50, 100, 500, 1000]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" @rowExpand="onRowExpand"
                @state-restore="onStateRestore($event)" @state-save="onStateSave($event)" @page="onPage($event)"
                @sort="onSort($event)" @filter="onFilter($event)" @update:selection="onSelect($event)"
                @row-dblclick="onRowDoubleClick" v-model:filters="filters" :totalRecords="totalRecords"
                v-model:selection="selectedRow" dataKey="Id" :metaKeySelection="false" :rowClass="rowClass"
                id="dataAppraisalIndex">
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #header="">
                        <Button v-show="canCreate && mine" :label="$t('create')" icon="pi pi-plus"
                            class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" />
                    </template>
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter"
                            :badge="filterBadge" badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">
                        <Button icon="pi pi-search" v-show="canView"
        class="p-button-rounded p-button-info mr-2 p-button-sm" 
        @click="
            (
                (this.mine && dataModel.data.S_Edit != null && dataModel.data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                (this.mine && ((dataModel.data.H_Edit != null && dataModel.data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || dataModel.data.K_Edit != null)) ||           
                (this.superior && (dataModel.data.H_Edit != null || dataModel.data.K_Edit != null)) ||
                (this.head && dataModel.data.K_Edit != null)
            )
                ? this.lockedDialog = true : editor(this.$FORM_MODE_VIEW, dataModel.data.Log_Id, dataModel.data)" />
                    <Button icon="pi pi-pencil" v-show="canEdit"
                        class="p-button-rounded p-button-success mr-2 p-button-sm"
                        @click="editor(this.$FORM_MODE_EDIT, dataModel.data.Id, dataModel.data)" 
                        v-if="this.AuthEditAppraisal(dataModel.data).isAllowtoEdit" />
                    </template>
                </Column>
                <Column field="NIK" :header="$t('nik')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('nik')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Employee_Name" :header="$t('name')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('name')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Grade" :header="$t('grade')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('grade')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Unit_Name" :header="$t('unit')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('unit')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Position_Name" :header="$t('position')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('position')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Structure" :header="$t('org_unit')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('org_unit')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="S_Score" :header="$t('score_superior')" :sortable="true" v-if="this.superior">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('score_superior')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : (data.S_Score ? data.S_Score + ' %' : '') }}
                    </template>
                </Column>
                <Column field="S_Rate" :header="$t('rate_superior')" :sortable="true" v-if="this.superior">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rate_superior')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : data.S_Rate }}
                    </template>
                </Column>
                <Column field="H_Score" :header="$t('score_head_superior')" :sortable="true" v-if="this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('score_superior')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : (data.H_Score ? data.H_Score + ' %' : '') }}
                    </template>
                </Column>
                <Column field="H_Rate" :header="$t('rate_head_superior')" :sortable="true" v-if="this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rate_superior')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : data.H_Rate }}
                    </template>
                </Column>                
                <Column field="F_Score" :header="$t('score_functional')" :sortable="true" v-if="this.superior || this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('score_functional')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.superior && data.Functional_Layer === 'SUPERIOR') || 
                        (this.head && data.Functional_Layer === 'HEAD SUPERIOR')) ?
                        (((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : (data.F_Score ? data.F_Score + ' %' : '')) : '' }}
                    </template>
                </Column>
                <Column field="F_Rate" :header="$t('rate_functional')" :sortable="true" v-if="this.superior || this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rate_functional')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.superior && data.Functional_Layer === 'SUPERIOR') || 
                        (this.head && data.Functional_Layer === 'HEAD SUPERIOR')) ?
                        (((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : data.F_Rate) : '' }}
                    </template>
                </Column>                
                <Column field="Score_Display" :header="$t('total_score')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('total_score')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : data.Score_Display + ' %' }}
                    </template>
                </Column>
                <Column field="Rate" :header="$t('rate')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rate')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ ((this.mine && data.S_Edit != null && data.S_Edit.indexOf(this.$store.getters.getUsername) == -1) ||
                        (this.mine && ((data.H_Edit != null && data.H_Edit.indexOf(this.$store.getters.getUsername) == -1) || data.K_Edit != null)) ||
                        (this.superior && (data.H_Edit != null || data.K_Edit != null)) ||
                        (this.head && data.K_Edit != null))
                        ? 'Locked' : data.Rate }}
                    </template>
                </Column>
                <Column field="S_Promot" :header="this.superior ? $t('promotion_status') : $t('promotbysuperior')"
                    :sortable="true" v-if="this.superior || this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('promotion_status')" />
                    </template>
                </Column>
                <Column field="H_Promot" :header="$t('promotion_status')" :sortable="true" v-if="this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('promotion_status')" />
                    </template>
                </Column>
                <Column field="Period_Year" :header="$t('period')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('period')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Created_Date" :header="$t('created_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('created_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Created_Date) }}
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('created_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('created_by')" />
                    </template>
                </Column>
                <Column field="S_Date" :header="$t('edit1_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" :placeholder="$t('edit1_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.S_Date) }}
                    </template>
                </Column>
                <Column field="S_Edit" :header="$t('edit1_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edit1_by')" />
                    </template>
                </Column>
                <Column field="F_Date" :header="$t('edit4_date')" dataType="date" :sortable="true" v-if="this.superior">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" :placeholder="$t('edit4_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.F_Date) }}
                    </template>
                </Column>
                <Column field="F_Edit" :header="$t('edit4_by')" :sortable="true" v-if="this.superior">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edit4_by')" />
                    </template>
                </Column>                
                <Column field="H_Date" :header="$t('edit2_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" :placeholder="$t('edit2_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.H_Date) }}
                    </template>
                </Column>
                <Column field="H_Edit" :header="$t('edit2_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edit2_by')" />
                    </template>
                </Column>
                <Column field="F_Date" :header="$t('edit4_date')" dataType="date" :sortable="true" v-if="this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" :placeholder="$t('edit4_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.F_Date) }}
                    </template>
                </Column>
                <Column field="F_Edit" :header="$t('edit4_by')" :sortable="true" v-if="this.head">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edit4_by')" />
                    </template>
                </Column>                
            </DataTable>

            <!-- <div style="margin-bottom: 20px;">
                <Button label="Assessed by Comitee" class="p-button-success" size="small"
                    style="background-color: #CCFF90 !important;color: black;float: right;" />
            </div> -->
        </template>
        <div v-html="this.reportTbl.content" v-if="this.excelTbl" v-show="false" />
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "Appraisal",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'appraisal-' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            editorPath: "/Appraisal/Editor",
            dataUrl: "appraisal/list",
            statusUrl: "appraisal/status",
            exportUrl: null,
            excelTbl: null,
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            statusList: null,
            selectedStatus: null,
            selectedCategoryIndex: 0,
            pageSize: 10,
            lockedDialog: false,
            scoreSelectionDialog: false,
            selectedRowData: null,
            pendingEditorMode: null,
            pendingEditorId: null,
        }
    },
    methods: {
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onSelect(event) {
            this.selectedRow = event.data;
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        editor(mode, id, data) {
            if (mode == this.$FORM_MODE_CREATE) {
                this.$router.push({ path: this.editorPath, query: { mode: mode, id: id, fromMenu: 'AppraisalIndex', fromTab: this.selectedCategoryIndex } });
            }
            else {
                const authResult = this.AuthEditAppraisal(data);
                const answerLogId = authResult.answerLogId;
                
                if (this.head && data && data.Functional_Layer == 'SUPERIOR') {
                    // Jika superior dan functional belum ada, langsung redirect
                    if (!data.S_Edit && !data.F_Edit) {
                        this.$router.push({ 
                            path: this.editorPath, 
                            query: { 
                                mode: mode, 
                                id: id, 
                                answerLogId: answerLogId, 
                                fromMenu: 'AppraisalIndex', 
                                fromTab: this.selectedCategoryIndex 
                            } 
                        });
                        return;
                    }
                    
                    // Jika salah satu atau keduanya ada, tampilkan popup untuk pilihan
                    this.selectedRowData = data;
                    this.pendingEditorMode = mode;
                    this.pendingEditorId = id;
                    this.scoreSelectionDialog = true;
                }
                else {
                    this.$router.push({ 
                        path: this.editorPath, 
                        query: { 
                            mode: mode, 
                            id: id, 
                            answerLogId: answerLogId, 
                            fromMenu: 'AppraisalIndex', 
                            fromTab: this.selectedCategoryIndex 
                        } 
                    });
                }
            }    
        },
        selectScore(scoreType) {
            const authResult = this.AuthEditAppraisal(this.selectedRowData);
            let answerLogId = authResult.answerLogId;
            
            if (scoreType === 'superior') {
                answerLogId = this.selectedRowData.S_Id ? this.selectedRowData.S_Id : this.selectedRowData.U_Id;
            } else if (scoreType === 'functional') {
                answerLogId = this.selectedRowData.F_Id ? this.selectedRowData.F_Id : this.selectedRowData.U_Id;
            }
            
            this.scoreSelectionDialog = false;
            
            this.$router.push({ 
                path: this.editorPath, 
                query: { 
                    mode: this.pendingEditorMode, 
                    id: this.pendingEditorId, 
                    answerLogId: answerLogId, 
                    fromMenu: 'AppraisalIndex', 
                    fromTab: this.selectedCategoryIndex 
                } 
            });
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.selectedRow = null;

            this.lazyParams = {
                start: this.start,
                pageSize: this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter,
                category: this.selectedStatus
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.loading = false;
                });
        },
        setFilters(defaultPeriod) {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (defaultPeriod && exportable[i].props.field == 'Period_Year') {
                    filterValue = this.$store.getters.getPeriorYear;
                }
                else if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;

            this.selectedCategoryIndex = event.selectedCategoryIndex ?? 0;
        },
        onStateSave(event) {
            event.selectedCategoryIndex = this.selectedCategoryIndex;
        },
        editOrder() {
            this.$router.push({ path: this.editorPath, query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id } });
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }

            this.sorts = [];
            this.loadLazyData();
        },
        onStatusChange(event) {
            this.selectedStatus = event.value;
            this.selectedCategoryIndex = event.index;
            this.$refs.dt.triggerSaveState();
            this.setFilters(this.$store.getters.getPeriorYear);
            this.loadLazyData();
        },
        rowClass(data) {
            return [{ 'classBg': data.K_Edit != null }];
        },
        exportExcel() {
            this.lazyParams = {
                start: this.start,
                sorts: this.dataSort,
                filters: this.dataFilter,
                pageSize: this.pageSize,
                category: this.selectedStatus                
            };

            if (this.mine)
                this.exportUrl = "appraisal/exportMine";
            else if (this.superior)
                this.exportUrl = "appraisal/exportSuperior";
            else if (this.head)
                this.exportUrl = "appraisal/exportHead";

            this.$axios.post(this.$API_URL + this.exportUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.excelTbl = {
                            header: response.data.data.header,
                            content: response.data.data.content,
                            title: response.data.data.title,
                        };

                        this.tableToExcel();
                    }

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                });
        },
        tableToExcel() {
            var uri = "data:application/vnd.ms-excel;base64,",
                template =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
                base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                },
                format = function (s, c) {
                    return s.replace(/{(\w+)}/g, function (m, p) {
                        return c[p];
                    });
                };
            var ctx = {
                worksheet: "Default" || "Worksheet",
                table: this.excelTbl.header + this.excelTbl.content,
            };
            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = this.excelTbl.title + "_" + currentDate;
            const link = document.createElement("a");
            link.href = uri + base64(format(template, ctx));
            link.download = fileName;
            link.click();
        },
        backToIndex() {
            this.lockedDialog = false;
        },
        AuthEditAppraisal(data) {
            var isAllowtoEdit = false;
            var answerLogId = 0; // Local variable instead of component property
            
            if (data.NIK == this.$store.getters.getUsername || data.Created_By.indexOf(this.$store.getters.getUsername) != '-1' ||
                data.NIK_Approval1 == this.$store.getters.getUsername || data.NIK_Approval2 == this.$store.getters.getUsername ||
                data.NIK_Functional == this.$store.getters.getUsername) {
                if (this.mine) {
                    if (data.S_Edit == null && data.H_Edit == null && data.K_Edit == null) {
                        isAllowtoEdit = true;
                        answerLogId = data.U_Id ? data.U_Id : data.Log_Id;
                    }
                    else if (data.NIK_Approval1 == this.$store.getters.getUsername && data.S_Can_Edit && data.H_Edit == null && data.K_Edit == null) {
                        isAllowtoEdit = true;
                        answerLogId = data.S_Id ? data.S_Id : data.Log_Id;
                    }
                    else if (data.NIK_Approval2 == this.$store.getters.getUsername && data.H_Can_Edit && data.K_Edit == null) {
                        isAllowtoEdit = true;
                        answerLogId = data.H_Id ? data.H_Id : data.Log_Id;
                    }                    
                }
                else if (this.superior) {
                    if (data.NIK_Approval1 == this.$store.getters.getUsername) {
                        if (data.S_Can_Edit && data.H_Edit == null && data.K_Edit == null) {
                            isAllowtoEdit = true;
                        }
                        answerLogId = data.S_Id ? data.S_Id : data.Log_Id;
                    }
                    else if (data.NIK_Functional == this.$store.getters.getUsername && data.Functional_Layer == 'SUPERIOR') {
                        if (data.F_Can_Edit && data.H_Edit == null && data.K_Edit == null) {
                            isAllowtoEdit = true;
                        }

                        if (data.F_Id)  {
                            answerLogId = data.F_Id;
                        }
                        else if (data.U_Id) {
                            answerLogId = data.U_Id;                            
                        }
                        else {
                            answerLogId = 0;
                        }
                    }               
                }
                else if (this.head) {
                    if (data.NIK_Approval2 == this.$store.getters.getUsername) {
                        if (data.H_Can_Edit && data.K_Edit == null) {
                            isAllowtoEdit = true;                        
                        }

                        if (data.H_Id) {
                            answerLogId = data.H_Id;
                        }
                        else {
                            answerLogId = data.Log_Id;
                        }
                    }
                    else if (data.NIK_Functional == this.$store.getters.getUsername && data.Functional_Layer == 'HEAD SUPERIOR') {
                        if (data.F_Can_Edit && data.K_Edit == null) {
                            isAllowtoEdit = true;
                        }

                        answerLogId = data.F_Id ? data.F_Id : data.S_Id ? data.S_Id : data.U_Id;                                                
                    }
                }
            }      

            return { isAllowtoEdit, answerLogId }; // Return both values
        }
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters(this.$store.getters.getPeriorYear);

        var self = this;

        this.$axios.get(this.$API_URL + this.statusUrl)
            .then((response) => {
                if (response.data.success) {
                    self.statusList = response.data.data;
                    var selectedStatusValue = Object.values(this.statusList)[this.selectedCategoryIndex];
                    if (selectedStatusValue == undefined) {
                        self.selectedStatus = Object.values(this.statusList)[0];
                    }
                    else {
                        self.selectedStatus = selectedStatusValue;
                    }

                    self.loadLazyData();
                }
                else {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 3000 });
                }

                self.loading = false;
            })
            .catch(function (err) {
                self.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 3000 });
                self.loading = false;
            });
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value && item.field != "Status") {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        },
        mine() {
            return this.selectedCategoryIndex == 0;
        },
        superior() {
            return this.selectedCategoryIndex == 1;
        },
        head() {
            return this.selectedCategoryIndex == 2;
        },
    },
}
</script>

<style>
#cardAppraisal .p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}

#dataAppraisalIndex .classBg {
    background-color: #CCFF90 !important;
}

#cardAppraisal .alert-info {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
}

#cardAppraisal .alert {
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
}

.score-selection-container {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin: 20px 0;
}

.score-option {
    flex: 1;
    text-align: center;
    border: 1px solid #e0e0e0;
    padding: 20px;
    border-radius: 8px;
    background-color: #f9f9f9;
    transition: all 0.3s ease;
}

.score-option.disabled-option {
    background-color: #f5f5f5;
    opacity: 0.6;
    border-color: #d0d0d0;
}

.score-option.disabled-option .score-label,
.score-option.disabled-option .score-details {
    color: #999;
}

.select-btn {
    width: 100px;
    margin-bottom: 15px;
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
}

.select-btn:disabled {
    background-color: #ccc !important;
    border-color: #ccc !important;
    cursor: not-allowed;
}

.score-label {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
    color: #333;
}

.score-details {
    color: #666;
    font-size: 14px;
}

.score-details div {
    margin-bottom: 5px;
}

.notes-section {
    margin-top: 20px;
    padding: 15px;
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
}

.notes-title {
    font-weight: bold;
    color: #856404;
    margin-bottom: 10px;
}

.notes-item {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #dc3545;
    font-size: 14px;
    margin-bottom: 5px;
}

.notes-item:last-child {
    margin-bottom: 0;
}
</style>